"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgetQueryFormApi = exports.fetchNPSWeeklyData = exports.fetchNPSDataInCSVFormat = exports.fetchNPSFeedback = exports.fetchNPSScore = exports.fetchNPSCount = void 0;
const toPascalCase = (value) => `${value[0].toUpperCase()}${value.slice(1, value.length)}`;
const fetchNPSCount = (callerQueryForm) => ({ accountId, testId, variationId, categoryName, dates }) => {
    const goalLabelParam = categoryName ? '' : '&goalLabel=npsGlobal';
    const metrics = categoryName ? `nps${toPascalCase(categoryName)}` : 'npsCount';
    const filters = [`campaignId==${testId}`, variationId ? `variationId==${variationId}` : '', 'hitType==NPS']
        .filter((filterItem) => Boolean(filterItem))
        .join(';');
    return callerQueryForm(`queryform/?account=${accountId}&metrics[]=${metrics}&maxValue=1&${dates}&filtersValue=${filters}${goalLabelParam}`).get();
};
exports.fetchNPSCount = fetchNPSCount;
const fetchNPSScore = (callerQueryForm) => ({ accountId, testId, variationsIds, dates }) => {
    const variationsFilters = variationsIds.map((variationId) => `variationId==${variationId}`).join(',');
    const filtersValue = [`campaignId==${testId}`, variationsFilters, 'hitType==NPS'].join(';');
    return callerQueryForm(`queryform/?account=${accountId}&metrics[]=nps&${dates}&filtersValue=${filtersValue}`).get();
};
exports.fetchNPSScore = fetchNPSScore;
const fetchNPSFeedback = (callerQueryForm) => ({ accountId, testId, variationId, dates, filters }) => {
    const filtersValue = [`campaignId==${testId}`, `variationId==${variationId}`, filters, 'hitType==NPS']
        .filter((filterValue) => Boolean(filterValue))
        .join(';');
    return callerQueryForm(`queryform/?account=${accountId}&dimensions[]=npsFeedback&maxValue=50000&dimensions[]=npsScore&dimensions[]=date&dimensions[]=countryIso&metrics[]=ghost&ignoreDistinct=1&${dates}&filtersValue=${filtersValue}`).get();
};
exports.fetchNPSFeedback = fetchNPSFeedback;
const fetchNPSDataInCSVFormat = (callerQueryForm) => ({ accountId, testId, variationId, dates }) => {
    return callerQueryForm(`queryform/?account=${accountId}&dimensions[]=npsFeedback&dimensions[]=npsScore&dimensions[]=url&maxValue=50000&dimensions[]=date&${dates}&format=csv&ignoreDistinct=1&filtersValue=campaignId==${testId};variationId==${variationId};hitType==NPS`).get();
};
exports.fetchNPSDataInCSVFormat = fetchNPSDataInCSVFormat;
const fetchNPSWeeklyData = (callerQueryForm) => ({ accountId, testId, variationId, dates }) => {
    return callerQueryForm(`queryform/?account=${accountId}&dimensions[]=date&metrics[]=nps&metrics[]=npsPassives&metrics[]=npsPromoters&metrics[]=npsDetractors&${dates}&sortMetrics[]=date&filtersValue=campaignId==${testId};variationId==${variationId};hitType==NPS`).get();
};
exports.fetchNPSWeeklyData = fetchNPSWeeklyData;
const widgetQueryFormApi = (callerQueryForm) => ({
    fetchNPSCount: (0, exports.fetchNPSCount)(callerQueryForm),
    fetchNPSScore: (0, exports.fetchNPSScore)(callerQueryForm),
    fetchNPSFeedback: (0, exports.fetchNPSFeedback)(callerQueryForm),
    fetchNPSDataInCSVFormat: (0, exports.fetchNPSDataInCSVFormat)(callerQueryForm),
    fetchNPSWeeklyData: (0, exports.fetchNPSWeeklyData)(callerQueryForm),
});
exports.widgetQueryFormApi = widgetQueryFormApi;
//# sourceMappingURL=apiQueryForm.js.map